import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  REVIEWS_PAGE_ADD_PATH,
  REVIEWS_PAGE_PATH,
  REVIEWS_PAGE_UPDATE_PATH,
} from "utils/constants/paths";

const ReviewsDetailsPage = Loadable(React.lazy(() => import("./View")));
const ReviewsDetailsPageAddOrUpdate = Loadable(
  React.lazy(() => import("./View/Details")),
);

export const ReviewsRoute: IRouteItem = {
  path: REVIEWS_PAGE_PATH,
  element: React.createElement(ReviewsDetailsPage),
  name: "Reviews Listing",
  children: [
    {
      name: "Add / Update",
      path: REVIEWS_PAGE_ADD_PATH,
      element: React.createElement(ReviewsDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: REVIEWS_PAGE_UPDATE_PATH,
      element: React.createElement(ReviewsDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
